// Use inverted messages if key pair doesn't exist in retrive message api
export const invertedMessages: Record<string, string> = {
  '{age} days': 'neo.aag.days_age',
  '{count} Critical Violations':
    'neo.aag.ad_filter_opt_critical_violation_count',
  '{count} filter applied': 'neo.aag.filter_applied',
  '{count} High Violations': 'neo.aag.ad_filter_opt_high_violation_count',
  '{count} Low Violations': 'neo.aag.ad_filter_opt_low_violation_count',
  '{count} Medium Violations': 'neo.aag.ad_filter_opt_mediumviolation_count',
  '{count} of the {totalCount} mitigating controls expires soon':
    'neo.aag.controls_expire_soon_count_msg',
  '{count} of the {totalCount} mitigating controls has expired':
    'neo.aag.controls_expired_count_msg',
  '{count} of the {totalCount} mitigating controls have expired':
    'neo.aag.controls_expired_multiple_count_msg',
  '{count} selected violations': 'neo.aag.selected_violations_count',
  '{count} Very High Violations':
    'neo.aag.ad_filter_opt_very_high_violation_count',
  '{count} Very Low Violations':
    'neo.aag.ad_filter_opt_very_low_violation_count',
  A: 'neo.aag.ad_filter_opt_A',
  'A to Z': 'neo.aag.sort_a_to_z',
  'Access Path': 'neo.aag.access_path',
  Account: 'Account_DISPLAYNAME.CERTIFICATIONS',
  'Account Status': 'sod.accounts.status.label',
  'Account Type': 'Account_ACCOUNTTYPE.ATTESTATIONS',
  'Account type1': 'neo.aag.ad_filter_opt_acc_type_1',
  'Account type2': 'neo.aag.ad_filter_opt_acc_type_2',
  Accounts: 'AccountsLabel',
  'Accounts with Most Violations': 'neo.aag.widget_account_most_violation',
  'Action Failed': 'CERTS_ACTION_FAILED',
  Active: 'CERTS_LIST_ACTIVE',
  'Actual Risk': 'neo.aag.ad_filter_opt_actual_risk',
  'Actual vs Potential': 'neo.aag.ad_filter_actual_potential',
  'Actual vs Potential status is not calculated':
    'neo.aag.actual_vs_potential_not_calculated',
  Add: 'Add',
  'Add Mitigating Control': 'neo.aag.add_mitigating_control',
  'Add or Remove Filters': 'CERTS_ADD_OR_REMOVE_FILTERS',
  'Add Review Comments': 'neo.aag.add_review_comment',
  'Added by': 'neo.aag.added_by',
  'Added By': 'neo.aag.added_by_label',
  'An error occurred while processing your request. Please verify your input or try again later.':
    'neo.aag.api_error_processing_msg',
  Application: 'Search.Label.Application',
  'Applications with Most Violations':
    'neo.aag.widget_application_most_violation',
  'Applied Mitigating Control': 'neo.aag.applied_mitigating_control_label',
  'Applied Mitigating Control ({count})':
    'neo.aag.mitigatedTab.details.mitigatingControl.title.count',
  Apply: 'advancefilter.label.Apply',
  'Apply one or more mitigating controls to violation':
    'neo.aag.apply_mitigating_controls_message',
  'Assigned Entitlement': 'neo.aag.assigned_ent_label',
  'Assigned Entitlements': 'neo.aag.assigned_ent_multi_label',
  'Assigned Entitlements Causing Most Violations':
    'neo.aag.widget_ass_ent_most_violation',
  B: 'neo.aag.ad_filter_opt_B',
  Back: 'CERTS_BACK',
  'Back to List View': 'neo.aag.back_to_list_view',
  'Business Process': 'neo.aag.ad_filter_bp',
  'Business Process with Most Violations': 'neo.aag.widget_bp_most_violation',
  C: 'neo.aag.ad_filter_opt_C',
  Cancel: 'SOD.Cancel.label',
  'Change End Date': 'CERTS_CHANGE_END_DATE',
  'Change Mitigating Control End Date':
    'neo.aag.change_mitigating_control_end_date',
  'Change Mitigating Controls': 'neo.aag.change_mitigating_control',
  'Change Review End Date': 'neo.aag.change_review_end_date',
  'Choose from over a dozen widget types to spotlight key data — such as risks, users, accounts, or roles with the most violations and recommended actions to help resolve them.':
    'neo.aag.widget_demo_desc',
  City: 'City.Default.label',
  'Classic Experience': 'neo.aag.classic_experience',
  clear: 'CopyAccess.searchbar.clear',
  Clear: 'CERTS_CLEAR',
  'Clear Filters': 'CERTS_CLEAR_FILTERS',
  'Clear Selection': 'CERTS_BULK_CLEAR_SELECTION',
  Closed: 'neo.aag.violations_page_closed_tab',
  'Collapse All': 'neo.aag.collapse_all',
  'COMING SOON': 'neo.aag.graph_coming_soon',
  Comment: 'Comment.Default.label',
  Comments: 'comments.ATTESTATIONS',
  'Company Name': 'companyname.sod.label',
  'Conflicting Job Functions': 'CERTS_CONFLICT_JOB_FUNCTIONS',
  Conflicts: 'CERTS_CONFLICTS',
  'Consult ({count})': 'neo.aag.consult_count',
  Continue: 'neo.aag.continue',
  'Contractors with Most Violations': 'neo.aag.widget_contract_most_violation',
  'Cost Center': 'Costcenter.Default.label',
  'Cost Centers with Most Violations': 'neo.aag.widget_cc_most_violation',
  'Could not Load Page': 'CERTS_GLOABL_ERROR_TITLE',
  Country: 'country.sod.label',
  Critical: 'SOD.RiskType.Critical',
  'Critical ({riskScore})': 'neo.aag.risk_score_type_critical',
  'Critical Access': 'neo.aag.ad_filter_opt_critical_access',
  CsnOnly: 'neo.aag.ad_filter_opt_csn',
  'Custom ({value})': 'neo.aag.ad_filter_opt_custom_val',
  'Custom Property 1': 'EntitlementTypeDetails.Label.CustomProperty1',
  'Customizable Widget': 'neo.aag.customizable_widget',
  Customize: 'neo.aag.customize',
  'Customize Widgets': 'neo.aag.customize_widgets',
  "Data couldn't be retrieved.": 'neo.aag.insights.error.message',
  'days old': 'neo.aag.ad_filter_opt_days_old',
  Department: 'neo.aag.ad_filter_department',
  'Departments with Most Violations': 'neo.aag.widget_dep_most_violation',
  Description: 'EntitlementTypeDetails.Label.Description',
  'details panel': 'neo.aag.details_pane',
  Detective: 'neo.aag.ad_filter_opt_detective',
  'Display Name': 'displayname.sod.label',
  'Displaying items related to the insight':
    'neo.aag.display_insights_violations',
  'Displaying violations selected in the graph.':
    'neo.aag.display_graph_violations',
  Email: 'email.sod.label',
  'Employee Class': 'employeeclass.sod.label',
  'Employee ID': 'Users.employeeid.label',
  'Employee Type': 'employeeType.sod.label',
  End: 'quickRequest.End',
  'End Date': 'EndDate',
  'Enter at least 1 character to view options.': 'neo.aag.ad_search_filter',
  Entitlement: 'Ent_DISPLAYNAME.CERTIFICATIONS',
  'Entitlement assigned to the account that led to the violation of this function.':
    'neo.aag.conflict_fn_tooltip_msg',
  'Entitlement Type': 'entitlement.entitlementtypekey.label',
  'Entitlement Value': 'entitlement.entitlement_value.label',
  'Entitlement Value Name': 'neo.aag.ad_filter_entitlement_value_name',
  'Entitlements with Inherent Risk': 'neo.aag.entitlement_inherent_risk',
  Entity: 'entity.sod.label',
  'Error loading Mitigating Control details, please try again.':
    'neo.aag.mitigatedTab.details.mitigatingControl.error',
  'Error loading summary details, please try again.':
    'neo.aag.api_error_details_msg',
  'Error loading User details, please try again.':
    'neo.aag.error_loading_user_details',
  'Expand Next Level': 'neo.aag.expand_next_level',
  'Expand/Collapse': 'neo.aag.expand_collapse',
  'Expired.': 'neo.aag.expired_with_dot',
  Expires: 'NewRequestHome.RecentRequests.Expires.Column.Label',
  'Expires Soon.': 'neo.aag.expire_soon',
  Field: 'risk.history.changed.type',
  Filter: 'CERTS_FILTER',
  FIREFIGHTERID: 'neo.aag.ad_filter_opt_firefighterid',
  'First Name': 'FirstName.Default.label',
  'First Used': 'neo.aag.first_used',
  Function: 'AOB.ORACLE-EBS.ENTITLEMENT_FIELD_MAPPING.FUNCTION.title',
  'Function Status': 'function.status.label',
  'Generate Report': 'neo.aag.generate_report',
  'Generate Report ({count})': 'neo.aag.generate_report_count',
  Glossary: 'Role_GLOSSARY.ATTESTATIONS',
  'Go Back': 'BackKey.label',
  Hide: 'control.sessions.hide',
  Hierarchy: 'neo.aag.tab_hierarchy',
  High: 'APPROVAL.CONFIDENCE.HIGH',
  'High ({riskScore})': 'neo.aag.risk_score_type_high',
  History: 'SOD.SeeHistory.label',
  'Identity Type': 'neo.aag.indentity_type',
  'In Remediation': 'neo.aag.violations_page_in_remediated_tab',
  'In Review': 'neo.aag.violations_page_inreview_tab',
  Inactive: 'CERTS_LIST_INACTIVE',
  'Inherent Risk for Entitlement': 'neo.aag.entitlement.risks.sidepanel.desc',
  'Insight Applied': 'neo.aag.insights_applied',
  Insights: 'neo.aag.violation_page_side_column_insights',
  'Interactive Violation Graph': 'neo.aag.interactive_violation_graph',
  Internal: 'neo.aag.ad_filter_opt_internal',
  'Job Code': 'JobCode.Default.label',
  'Job Description': 'jobDescription.sod.label',
  'Job id': 'neo.aag.violation_risk_job_id',
  'Keep up the good work!': 'neo.aag.api_no_data_open_tab_msg',
  L: 'neo.aag.ad_filter_opt_L',
  'Last 7 days': 'neo.aag.ad_filter_opt_last_7_days',
  'Last 14 days': 'neo.aag.ad_filter_opt_last_14_days',
  'Last 24 hours': 'neo.aag.ad_filter_opt_last_24_hrs',
  'Last 30 days': 'neo.aag.ad_filter_opt_last_30_days',
  'Last Name': 'LastName.Default.label',
  'Last Used': 'neo.aag.last_used',
  'Latest Activity': 'neo.aag.latest_activity',
  'Least Critical': 'neo.aag.sort_least_critical',
  'Less than 7 days old': 'neo.aag.ad_filter_opt_less_7_days',
  'Less than 14 days old': 'neo.aag.ad_filter_opt_less_14_days',
  'Less than 30 days old': 'neo.aag.ad_filter_opt_less_20_days',
  List: 'neo.aag.violation_page_list',
  'Loading...': 'IdentityMnM.home.loading.text',
  'Locations with Most Violations': 'neo.aag.widget_location_most_violation',
  Locked: 'neo.aag.ad_filter_opt_locked',
  Low: 'APPROVAL.CONFIDENCE.LOW',
  'Low ({riskScore})': 'neo.aag.risk_score_type_low',
  Manager: 'manager.sod.label',
  'MC Assigned End Date': 'neo.aag.ad_filter_mc_end_date',
  'MC Assigned Start Date': 'neo.aag.ad_filter_mc_start_date',
  'MC Expiry Date': 'neo.aag.ad_filter_mc_expiry_date',
  Medium: 'APPROVAL.CONFIDENCE.MEDIUM',
  'Medium ({riskScore})': 'neo.aag.risk_score_type_medium',
  Mitigate: 'neo.aag.mitigate_label',
  'Mitigate ({count})': 'neo.aag.mitigate_count',
  Mitigated: 'SOD.PreMitigated.MitigatedLabel',
  'Mitigated {count}': 'neo.aag.mitigated_count',
  'Mitigated by': 'neo.aag.mitigated_by',
  'Mitigating Control': 'ReqHist.SOD.Mitigation.MitigatingControl',
  'Mitigating Control {count}': 'neo.aag.mitigating_control_count',
  'Mitigating Control Added': 'neo.aag.history_mitigate_control_added',
  'Mitigating Control End Date Changed':
    'neo.aag.history_mitigate_control_end_date_change',
  'Mitigating Control Name': 'SOD.MC.label',
  More: 'View.More',
  'More than 30 days old': 'neo.aag.ad_filter_opt_more_30_days',
  'Most Critical': 'neo.aag.sort_most_critical',
  'Move to “In Review”': 'neo.aag.move_in_review',
  'Moved From Status to Close': 'neo.aag.history_status_to_close',
  'Moved to In Review': 'neo.aag.history_move_to_in_review',
  'Moved To In-Remediation': 'neo.aag.history_move_to_in_remediation',
  'Moved to In-Review': 'neo.aag.history_move_to_in_review_dash',
  'Multiple occurrences {currentCount} of {totalCount}':
    'neo.aag.multiple_occurances',
  'Newest to Oldest': 'neo.aag.sort_new_to_old',
  Next: 'CERTS_NEXT',
  'Next 7 days': 'neo.aag.ad_filter_opt_nxt_7_days',
  'Next 14 days': 'neo.aag.ad_filter_opt_nxt_14_days',
  'Next 24 hours': 'neo.aag.ad_filter_opt_nxt_24_hrs',
  'Next 30 days': 'neo.aag.ad_filter_opt_nxt_30_days',
  'No data found!': 'neo.aag.api_no_data_found',
  'No Matching Results Found': 'neo.aag.api_no_data_title',
  'No Open Violations': 'neo.aag.api_no_data_title_open_tab',
  'No records match your search': 'neo.aag.no_records_message',
  'No Results Found!': 'neo.aag.api_no_function_title',
  None: 'AOB.DnD.None',
  'Not Calculated': 'neo.aag.ad_filter_opt_not_calculated',
  'Not Provided': 'CERTS_NOT_PROVIDED',
  'Number of Assigned Entitlements': 'neo.aag.number_assigned_ent',
  'Number of Violating Entitlements': 'neo.aag.number_violating_ent',
  Object: 'neo.aag.object',
  'Oldest to Newest': 'neo.aag.sort_old_to_new',
  Open: 'REQUEST.ACCESS.STATUS.OPEN',
  'Open Risk SodInsights Aside': 'neo.aag.violations_page_insights_toggler',
  'Org Unit ID': 'orgunitid.sod.label',
  'Orphan Accounts with Most Violations':
    'neo.aag.widget_orp_acc_most_violation',
  'Please select at least one mitigating control.':
    'neo.aag.select_at_least_one_message',
  'Potential Risk': 'neo.aag.ad_filter_opt_potential_risk',
  Preventative: 'neo.aag.ad_filter_opt_preventative',
  Priority: 'neo.aag.priority_label',
  Privileged: 'PRIVILEGED.ATTESTATIONS',
  'Provide a reason for your decision': 'CERTS_TERMINATE_PLACEHOLDER',
  'Re-Open': 'neo.aag.repoen',
  'Recommendations to Reduce Violations':
    'neo.aag.widget_recommendation_reduce_violation',
  'Recommended Only': 'neo.aag.recommended_only_label',
  Refresh: 'Refresh.ATTESTATIONS',
  Region: 'region.sod.label',
  Remediate: 'neo.aag.remediate_label',
  'Remediation Request Approved': 'neo.aag.history_remediation_request_approve',
  'Remediation Request Rejected': 'neo.aag.history_remediation_request_reject',
  'Remediation Requested': 'neo.aag.history_remediation_request',
  'Remediation Task Created': 'neo.aag.history_remediation_task_created',
  'Remediation Task Failed': 'neo.aag.history_remediation_task_failed',
  Remove: 'pam.quickrequest.invalid.template.remove.label',
  'Remove Filter': 'CERTS_REMOVE_FILTER',
  'Remove Mitigating Control': 'neo.aag.remove_mitigating_control',
  Retry: 'Retry.Default.label',
  'Return to Classic Experience to Take Actions':
    'neo.aag.return_to_classic_for_actions',
  'Return to the Classic Experience':
    'neo.aag.return_to_classic_experience_label',
  'Return to the Classic Experience?':
    'neo.aag.return_to_the_classic_experience',
  'Review Comments Added': 'neo.aag.history_review_comment_added',
  'Review End Date Changed': 'neo.aag.history_review_end_date_change',
  'Risk Description': 'riskDesc.sod.label',
  'Risk Name': 'risks.riskname.label',
  'Risk Owner': 'RiskOwner.Default.label',
  'Risk Priority': 'risks.priority.label',
  'Risk Score': 'Users.riskscore.label',
  'Risk Type': 'risks.risktype.label',
  'Risks with Most Violations': 'neo.aag.widget_risk_most_violation',
  Role: 'Role_DISPLAYNAME.CERTIFICATIONS',
  'Roles Causing Most Violations': 'neo.aag.widget_role_most_violation',
  'Rule Value': 'neo.aag.rule_value',
  Ruleset: 'Rulesets.ruleset.label',
  'Rulesets with Most Violations': 'neo.aag.widget_ruleset_most_violation',
  S: 'neo.aag.ad_filter_opt_S',
  'SAP Roles Causing Most Violations': 'neo.aag.widget_sap_role_most_violation',
  Search: 'neo.aag.search',
  'Search failed; please try again': 'neo.aag.filter_search_failed_text',
  'Search your text here...': 'neo.aag.search_text_here',
  'Select All ({count})': 'neo.aag.select_all_with_count',
  'Select up to {count} widgets to be displayed and drag to reorder them.':
    'neo.aag.customize_widgets_subtitle',
  Selected: 'REASSSIGN_SELECTED',
  'Selection Required': 'neo.aag.selection_required_message',
  service: 'neo.aag.ad_filter_opt_service',
  'Service Account': 'MSA.SERVICE.ACCOUNT',
  'Service Accounts with Most Violations':
    'neo.aag.widget_service_acc_most_violation',
  'Show More': 'CERTS_SHOW_MORE',
  SOD: 'Icon.SOD',
  'Something went wrong while loading the data. Please reload or check back later.':
    'neo.aag.api_error_data_title_2',
  'Something went wrong while loading the page.':
    'neo.aag.api_error_data_title',
  Sort: 'CERTS_SORT',
  Source: 'IdentityMnM.home.source.tooltip',
  'Sox Critical': 'soxcritical.ATTESTATIONS',
  'SOX Critical Entitlements with Most Violations':
    'neo.aag.widget_sox_most_violation',
  Standard: 'neo.aag.ad_filter_opt_standard',
  Start: 'quickRequest.Start',
  'Start Date': 'StartDate',
  Summary: 'CERTS_SUMMARY',
  'Sys Critical': 'Role_SYSCRITICAL.ATTESTATIONS',
  'System Username': 'SystemUserName.Default.label',
  'T-Codes Causing Most Violations': 'neo.aag.widget_tcode_most_violation',
  'Tap anywhere on the row to open the details panel.':
    'neo.aag.tap_to_open_panel',
  TEST: 'neo.aag.ad_filter_opt_test',
  'The direct cause of the violation of the function.':
    'neo.aag.direct_fn_cause_description',
  'The mitigating control expires soon': 'neo.aag.controls_expire_soon_msg',
  "The new experience doesn't support actions yet.":
    'neo.aag.new_exp_not_support_actions',
  'The new experience is does not support any actions yet. Please return to the classic view to take actions.':
    'neo.aag.new_exp_not_support_actions_desc',
  'The number of visible attributes depends on the size of your browser. Any attributes not shown are visible in the':
    'neo.aag.col_filter_description',
  "The user has access to conflicting entitlements but has only used a subset. A violation could occur but hasn't yet been confirmed by full usage":
    'neo.aag.potential_risk_description',
  'The user has performed actions using entitlements from all functions involved in the risk. This is a confirmed SoD violation based on usage data.':
    'neo.aag.confirmed_sod_violation_tooltip_msg',
  'This entitlement appears in more than one job function within the same violation. This indicates this entitlement carries inherent risk.':
    'neo.aag.multiple_occurances_description',
  'This page of the violations did not load properly due to a network issue. Please refresh or try again later.':
    'neo.aag.could_not_load_description',
  'This upcoming graph will visualize the same violation data shown in the list view, displayed across a risk score and age matrix. It offers a more interactive way to explore violations, with built-in insights and filters to help you identify trends and outliers.':
    'neo.aag.interactive_violation_graph_desc',
  Time: 'sessions.details.time',
  to: 'role.review.to',
  'Total Used': 'neo.aag.total_used',
  Trust: 'CERTS_TRUST',
  'Trust Block Coming Soon...': 'neo.aag.trust_coming_soon',
  'Try clearing the search or check back later.':
    'neo.aag.api_no_data_search_msg',
  'Try refreshing, or check back later. If the issue persists, contact your administrator.':
    'neo.aag.api_error_data_msg',
  'Try updating the filters or check back later.':
    'neo.aag.api_no_data_filter_msg',
  Type: 'CERTS_REVIEW_STEP2_TYPE',
  'Type more than 2 characters to see results.':
    'neo.aag.type_more_than_2_characters_to_see_results',
  'Type number': 'neo.aag.ad_filter_opt_type_num',
  Unlocked: 'neo.aag.ad_filter_opt_unlocked',
  'Update Date': 'Endpoint_UPDATEDATE.ATTESTATIONS',
  User: 'User_DISPLAYNAME.CERTIFICATIONS',
  'User Not Found.': 'neo.aag.user_not_found',
  'User Status': 'statuskey.sod.label',
  'User Value': 'neo.aag.user_value',
  Userlock: 'neo.aag.ad_filter_userlock',
  Username: 'User_USERNAME.ATTESTATIONS',
  Users: 'CERTS_BULK_USERS',
  'Users with Most Violations': 'neo.aag.widget_user_most_violation',
  'Very High': 'neo.aag.ad_filter_opt_very_high',
  'Very High ({riskScore})': 'neo.aag.risk_score_type_very_high',
  'Very Low': 'neo.aag.ad_filter_opt_very_low',
  'Very Low ({riskScore})': 'neo.aag.risk_score_type_very_low',
  'View All': 'Admin.Log.Viewer.filter.viewAll',
  'View Details': 'CatalogApplicationViewDetails',
  'View Graph': 'neo.aag.view_graph',
  'View History': 'CERTS_VIEW_HISTORY',
  'View List': 'neo.aag.view_list',
  'Violating Entitlement': 'SOD.appReq.VioEntitlement',
  'Violating Privileged Entitlement': 'neo.aag.violation_prv_ent',
  'Violating SOX Critical Entitlement': 'neo.aag.violation_sox_crt_ent',
  'Violating Sys Critical Entitlement': 'neo.aag.violation_sys_crt_ent',
  'Violation Age': 'neo.aag.ad_filter_violation_age',
  'Violation Age (Day)': 'neo.aag.violation_age_by_day',
  'Violation by': 'neo.aag.violation_by',
  'Violation by {username}': 'neo.aag.violation_by_username',
  'Violation Closed': 'neo.aag.history_violation_closed',
  'Violation Found': 'neo.aag.history_violation_found',
  'Violation Mitigated': 'neo.aag.history_violation_mitigate',
  'Violation Origin': 'neo.aag.ad_filter_violation_origin',
  'Violation Re-Opened': 'neo.aag.history_violation_re_opened',
  'Violation Status': 'neo.aag.violation_status',
  Violations: 'neo.aag.tab_violations',
  VIOLATIONS: 'neo.aag.violations_uppercase',
  'Violations Detection': 'neo.aag.violations_detection',
  'Violations Page': 'neo.aag.ad_filter_violations_page',
  'You can switch back to the new experience at any time.':
    'neo.aag.you_can_switch_back_to_neo',
  "You've reached maximum number of columns sets allowed. Remove existing ones to add more.":
    'neo.aag.col_filter_limit_msg',
  "You've reached maximum number of filter sets allowed. Remove existing ones to add more.":
    'neo.aag.ad_filter_add_remove_filters_with_limit',
  "You've reached the max number": 'neo.aag.max_limit_reached',
  'Z to A': 'neo.aag.sort_z_to_a',
} as const;

// Use below if key is available
export const aagLabels: Record<string, string> = {} as const;
